export default "__VITE_ASSET__B3F1F5fw__"